import type { ReactNode } from 'react';

export const symbol_nest_cam_stand: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360-668q-50 29-81 78t-35 109l-25 301h523l-26-302q-4-60-35-108.5T600-668v108q0 50-35 85t-85 35q-50 0-85-35t-35-85v-108Zm162.5 150.5Q540-535 540-560v-160q0-25-17.5-42.5T480-780q-25 0-42.5 17.5T420-720v160q0 25 17.5 42.5T480-500q25 0 42.5-17.5ZM218-120q-26 0-44-19.5T158-185l26-303q6-85 54.5-150T361-735q6-45 39.5-75t79.5-30q46 0 79.5 30t39.5 75q74 32 122.5 97T776-488l26 303q2 26-16 45.5T742-120H218Z"
		/>
	</svg>
);
